<template>
  <div>
    <cabecalho-pagina
      :titulo="$t('modulos.roteiro_envio_material.titulos.listagem')"
      :total-registros="tabela.quantidadeItens"
      :titulo-botao-novo="$t('modulos.roteiro_envio_material.titulos.novo')"
      :sem-botao-ok="!buscarPermissao('RoteiroEnvioMaterial', 'Inserir')"
      :sem-filtro="!buscarPermissao('RoteiroEnvioMaterial', 'Listar')"
      @abrirNovo="abrirNovo"
      @filtrar="filtrar"
    >
      <template v-slot:filtro="{ filtro }">
        <filtro :filtro="filtro" />
      </template>
    </cabecalho-pagina>
    <botao-padrao
      v-if="podeExcluir && buscarPermissao('RoteiroEnvioMaterial', 'Deletar')"
      class="my-2"
      outlined
      color="danger"
      @click="excluirRegistros"
    >
      <v-icon>$mdiTrashCanOutline</v-icon>
      {{ $t('geral.botoes.excluir') }}
    </botao-padrao>

    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="tabela.selecionados"
      filtros-com-colunas
      class="mt-2"
      mostrar-acoes
      selecionar-colunas
      sem-selecionar-todos
      :mostrar-seletor="buscarPermissao('RoteiroEnvioMaterial', 'Deletar')"
      :colunas="tabela.colunas"
      :dados="tabela.dados"
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :pagina="tabela.paginaAtual"
      @paginar="listarRegistros"
      @filtrarGlobal="filtrarGlobal"
      @filtroGlobal="filtroGlobal"
      @nova-ordenacao="ordenacaoColuna"
    >
      <template v-slot:acoes="{ slotProps }">
        <dropdown-padrao text color="secondary">
          <template #botao>
            <v-icon> $dotsVertical </v-icon>
          </template>
          <div>
            <dropdown-padrao-item
              v-if="buscarPermissao('RoteiroEnvioMaterial', 'Programar')"
              text
              color="secondary"
              :disabled="podeProgramar(slotProps.data)"
              @click="abrirEditar(slotProps.data)"
            >
              {{ $t('geral.botoes.programar') }}
            </dropdown-padrao-item>
            <dropdown-padrao-item
              v-if="buscarPermissao('RoteiroEnvioMaterial', 'Executar')"
              text
              color="secondary"
              :disabled="podeIniciar(slotProps.data)"
              @click="iniciarExecucao(slotProps.data)"
            >
              {{ $t('geral.botoes.iniciar_execucao') }}
            </dropdown-padrao-item>
            <dropdown-padrao-item
              v-if="buscarPermissao('RoteiroEnvioMaterial', 'Executar')"
              text
              color="secondary"
              :disabled="podeRetomar(slotProps.data)"
              @click="retomarExecucao(slotProps.data)"
            >
              {{ $t('geral.botoes.retomar_execucao') }}
            </dropdown-padrao-item>
            <dropdown-padrao-item
              v-if="buscarPermissao('RoteiroEnvioMaterial', 'Executar')"
              text
              color="secondary"
              :disabled="podeRetomar(slotProps.data)"
              @click="finalizarExecucao(slotProps.data)"
            >
              {{ $t('geral.botoes.finalizar_execucao') }}
            </dropdown-padrao-item>
            <dropdown-padrao-item
              v-if="buscarPermissao('RoteiroEnvioMaterial', 'Visualizar')"
              text
              color="secondary"
              @click="abrirVisualizar(slotProps.data)"
            >
              {{ $t('geral.botoes.visualizar') }}
            </dropdown-padrao-item>
          </div>
        </dropdown-padrao>
      </template>
    </tabela-padrao-prime-vue>
  </div>
</template>

<script>
import helpers from '@/common/utils/helpers';
import CabecalhoPagina from '@/components/layout/CabecalhoPagina.vue';
import RoteiroEnvioMaterialService from '@/common/services/cadastros/RoteiroEnvioMaterialService.js';
import Filtro from './filtro.vue';
import moment from 'moment';
import EnumeradorService from '@common/services/cadastros/EnumeradorService';
import { mapActions } from 'vuex';
export default {
  components: {
    CabecalhoPagina,
    Filtro,
  },
  data() {
    return {
      opcoes: {
        situacao: helpers.SituacaoEnvioMaterialEnum,
        enumSituacaoEnumSituacaoRoteiro: [],
      },
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.roteiro_envio_material.tabela.codigo'),
            sortable: true,
          },
          {
            value: 'dataAgendamento',
            text: this.$t(
              'modulos.roteiro_envio_material.tabela.data_agendamento'
            ),
            sortable: true,
            formatter: (v) => {
              if (v) return helpers.formatarDataBr(v, false);
            },
          },
          {
            value: 'situacao',
            text: this.$t('modulos.roteiro_envio_material.tabela.situacao'),
            sortable: true,
            formatter: (v) => {
              if (v)
                return this.opcoes.enumSituacaoEnumSituacaoRoteiro.find(
                  (el) => el.value === v
                )?.text;
            },
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
      filtroAplicado: { filter: '' },
      colunaOrdenada: '',
    };
  },
  computed: {
    podeExcluir() {
      return this.tabela.selecionados.length > 0;
    },
  },
  created() {
    helpers.redirecionarSemPermissao(this, 'RoteiroEnvioMaterial', 'Listar');
    const filtros = this.buscarStateFiltros();
    this.filtroAplicado = filtros?.filtroAplicado ?? { filter: '' };
    this.tabela.paginaAtual = filtros?.paginaAtual ?? 1;
    this.tabela.porPagina = filtros?.porPagina ?? 10;
  },
  mounted() {
    this.buscarEnumSituacaoRoteiro();
    if (window.innerWidth < 600) {
      this.$router.push({
        name: 'roteiro-executar-envio-material',
      });
      return;
    }
    this.colunaOrdenada = '-DataAgendamento';
    this.listarRegistros();
    this.$store.dispatch(
      'Layout/alterarTituloPagina',
      this.$t('modulos.roteiro_envio_material.titulos.listagem')
    );
  },
  methods: {
    ...mapActions('Roteiro', ['updateRoteiroId', 'updateDataAgendamento']),
    buscarPermissao(funcionalidade, funcionalidadeAcao) {
      return helpers.buscarStatePermissoes(
        this,
        funcionalidade,
        funcionalidadeAcao
      );
    },
    filtrar: function (filtro) {
      this.filtroAplicado = { ...filtro, filter: this.filtroAplicado.filter };
      this.$refs.tabela.atualizarPaginaAtual();
      this.listarRegistros(1);
    },
    listarRegistros: function (
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      this.tabela.porPagina = porPagina;
      this.salvarStateFiltros({
        filtroAplicado: this.filtroAplicado,
        paginaAtual,
        porPagina,
      });
      let parametros = {
        sort: this.colunaOrdenada,
        page: paginaAtual,
        amountPerPage: porPagina,
        ...helpers.formattingParameters(this.filtroAplicado),
      };
      this.$store.dispatch('Layout/iniciarCarregamento');
      this.tabela.dados = [];
      RoteiroEnvioMaterialService.listar(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;
          this.tabela.quantidadeItens = res.data.totalItems;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    excluirRegistros: async function () {
      this.confirmarExcluir().then(() => {
        this.$store.dispatch('Layout/iniciarCarregamento');
        const listaIdExclusao = this.tabela.selecionados.map((s) => s.id);
        RoteiroEnvioMaterialService.excluir(listaIdExclusao)
          .then(() => {
            this.listarRegistros();
            this.toastSucesso(
              this.$t(`modulos.roteiro_envio_material.exclusao_sucesso`)
            );
            this.tabela.selecionados = [];
          })
          .finally(() => {
            this.$store.dispatch('Layout/terminarCarregamento');
          });
      });
    },
    abrirNovo: function () {
      this.$router.push({ name: 'roteiro-envio-material-novo' });
    },
    abrirEditar: function (item) {
      this.$router.push({
        name: 'roteiro-envio-material-editar',
        params: { id: item.id },
      });
    },
    abrirVisualizar: function (item) {
      this.$router.push({
        name: 'roteiro-envio-material-visualizar',
        params: { id: item.id },
      });
    },
    podeProgramar: function (item) {
      const dataAgendamento = new Date(item.dataAgendamento);
      const dataAtual = new Date();

      dataAgendamento.setHours(0, 0, 0, 0);
      dataAtual.setHours(0, 0, 0, 0);

      return !(
        item.situacao === 'Pendente' ||
        (item.situacao === 'Programado' && dataAgendamento <= dataAtual)
      );
    },
    podeIniciar: function (item) {
      const hoje = moment(new Date());
      return !(
        item.situacao === 'Programado' &&
        hoje.isSame(item.dataAgendamento, 'date')
      );
    },
    podeRetomar: function (item) {
      return item.situacao !== 'EmExecucao';
    },
    iniciarExecucao: function (item) {
      this.roteiroId = item.id;
      this.updateRoteiroId(this.roteiroId);

      this.dataAgendamento = item.dataAgendamento;
      this.updateDataAgendamento(this.dataAgendamento);
      this.$router.push({
        name: 'roteiro-executar-envio-material',
      });
    },
    retomarExecucao: function (item) {
      this.roteiroId = item.id;
      this.updateRoteiroId(this.roteiroId);

      this.dataAgendamento = item.dataAgendamento;
      this.updateDataAgendamento(this.dataAgendamento);

      this.$router.push({
        name: 'roteiro-executar-envio-material',
      });
    },
    finalizarExecucao: function (item) {
      this.roteiroId = item.id;
      this.updateRoteiroId(this.roteiroId);

      this.dataAgendamento = item.dataAgendamento;
      this.updateDataAgendamento(this.dataAgendamento);
      this.$router.push({
        name: 'roteiro-executar-envio-material-finalizar',
      });
    },
    buscarEnumSituacaoRoteiro: async function () {
      await EnumeradorService.buscar('EnumSituacaoRoteiro').then((res) => {
        this.opcoes.enumSituacaoEnumSituacaoRoteiro = res;
      });
    },
    buscarStateFiltros() {
      return this.$store.getters['Filtros/filtros'][this.$route.name];
    },
    salvarStateFiltros(dados) {
      this.$store.dispatch('Filtros/adicionarFiltro', {
        rota: this.$route.name,
        dados,
      });
    },
    filtroGlobal(v) {
      this.filtroAplicado.filter = v;
    },
    filtrarGlobal() {
      this.listarRegistros();
    },
    ordenacaoColuna(ordem) {
      this.colunaOrdenada = ordem;
      this.listarRegistros();
    },
  },
};
</script>
